/**
 *
 * @param accessors
 * @param object
 * @returns value form the object
 */
export var multipleStringAccessorExtractor = function (accessors, object) {
    var accessors_arr = accessors.split('.');
    var object_value = object;
    for (var index = 0; index < accessors_arr.length; index++) {
        var accessor = accessors_arr[index];
        if (object_value === undefined) {
            break;
        }
        object_value = object_value[accessor];
    }
    return object_value;
};
export var to1stCapital = function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
//# sourceMappingURL=JSONUtils.js.map